import { render, staticRenderFns } from "./HtmlText.vue?vue&type=template&id=7b3fc844&"
import script from "./HtmlText.vue?vue&type=script&lang=ts&setup=true&"
export * from "./HtmlText.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./HtmlText.vue?vue&type=style&index=0&id=7b3fc844&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports